import Sidebar from "./SideBar.vue";
import SidebarItem from "./SidebarItem.vue";

const SidebarStore = {
    showSidebar: false,
    sidebarLinks: [],
    isMinimized: false,
    eventBus: null,
    displaySidebar(value) {
        this.showSidebar = value;
    },
    toggleMinimize() {
        document.body.classList.toggle("sidebar-mini");
        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(() => {
            window.dispatchEvent(new Event("resize"));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(() => {
            clearInterval(simulateWindowResize);
        }, 1000);

        this.isMinimized = !this.isMinimized;
        
        // Emit minimize state change event
        if (this.eventBus) {
            this.eventBus.$emit('sidebar-minimize-changed', this.isMinimized);
        }
    },
    setMinimizeState(isMinimized, skipAnimation = false) {
        if (this.isMinimized === isMinimized) return;
        
        if (isMinimized) {
            document.body.classList.add("sidebar-mini");
        } else {
            document.body.classList.remove("sidebar-mini");
        }
        
        this.isMinimized = isMinimized;
        
        if (!skipAnimation) {
            // simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(() => {
                window.dispatchEvent(new Event("resize"));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(() => {
                clearInterval(simulateWindowResize);
            }, 1000);
        }
    }
};

const SidebarPlugin = {
    install(Vue, options) {
        if (options && options.sidebarLinks) {
            SidebarStore.sidebarLinks = options.sidebarLinks;
        }
        const app = new Vue({
            data: function() {
                return {
                    sidebarStore: SidebarStore
                };
            }
        });
        
        // Set up event bus for minimize state changes
        SidebarStore.eventBus = app;
        
        Vue.prototype.$sidebar = app.sidebarStore;
        Vue.component("SideBar", Sidebar);
        Vue.component("SidebarItem", SidebarItem);
    }
};

export default SidebarPlugin;
